export default "__VITE_ASSET__HfX5fERt__"